module.exports = __webpack_public_path__ + "img/singles-feature.502af878.jpg";